export enum PrivacyStatus {
  Private = 'private',
  Public = 'public',
  Unlisted = 'unlisted',
}

export enum YoutubeCategories {
  FilmAnimation = '1', // Film & Animation
  AutosVehicles = '2', // Autos & Vehicles
  Music = '10', // Music
  PetsAnimals = '15', // Pets & Animals
  Sports = '17', // Sports
  TravelEvents = '19', // Travel & Events
  Gaming = '20', // Gaming
  PeopleBlogs = '22', // People & Blogs
  Comedy = '23', // Comedy
  Entertainment = '24', // Entertainment
  NewsPolitics = '25', // News & Politics
  HowtoStyle = '26', // Howto & Style
  Education = '27', // Education
  ScienceTech = '28', // Science & Technology
  NonprofitsActivism = '29', // Nonprofits & Activism
}

export interface YouTubeMetadata {
  privacyStatus: PrivacyStatus;
  category: YoutubeCategories;
}

export const youtubeDefaultMetadata: YouTubeMetadata = {
  privacyStatus: PrivacyStatus.Public,
  category: YoutubeCategories.Entertainment,
};

export const YoutubeCategoryLabels: Record<YoutubeCategories, string> = {
  [YoutubeCategories.FilmAnimation]: 'Film & Animation',
  [YoutubeCategories.AutosVehicles]: 'Autos & Vehicles',
  [YoutubeCategories.Music]: 'Music',
  [YoutubeCategories.PetsAnimals]: 'Pets & Animals',
  [YoutubeCategories.Sports]: 'Sports',
  [YoutubeCategories.TravelEvents]: 'Travel & Events',
  [YoutubeCategories.Gaming]: 'Gaming',
  [YoutubeCategories.PeopleBlogs]: 'People & Blogs',
  [YoutubeCategories.Comedy]: 'Comedy',
  [YoutubeCategories.Entertainment]: 'Entertainment',
  [YoutubeCategories.NewsPolitics]: 'News & Politics',
  [YoutubeCategories.HowtoStyle]: 'Howto & Style',
  [YoutubeCategories.Education]: 'Education',
  [YoutubeCategories.ScienceTech]: 'Science & Technology',
  [YoutubeCategories.NonprofitsActivism]: 'Nonprofits & Activism',
};
